const isPro = Object.is(process.env.NODE_ENV, 'production')

console.log(isPro);

module.exports = {
	baseUrl: isPro ? 'https://api-buyer.2041mall.com' : 'https://api-buyer.2041mall.com'
  // baseUrl: isPro ? 'http://book-mall-buyer.walle.xin' : 'http://book-mall-buyer.walle.xin'
  // baseUrl: isPro ? 'https://api.xn--6orz56b.com' : 'https://api.xn--6orz56b.com'
}
